// frozen_string_literal: true

import { Controller } from "@hotwired/stimulus";
import {
  generateChartCanvas,
  canvasToBlob,
  uploadChartImage,
} from "../helpers/chart_helpers";

export default class extends Controller {
  static targets = ["progressBar", "progressText"];
  static values = {
    total: Number,
    date: String,
  };

  connect() {
    console.log(`批量图片生成器已连接，共 ${this.totalValue} 个任务`);
    // 自动开始生成
    if (this.totalValue > 0) {
      this.startGeneration();
    }
  }

  startGeneration() {
    const generators = document.querySelectorAll(".chart-generator");
    let currentIndex = 0;
    let completedCount = 0;

    const generateNext = async () => {
      if (currentIndex >= generators.length) {
        console.log("全部完成");
        setTimeout(() => {
          window.location.href = this.getReturnUrl();
        }, 2000);
        return;
      }

      const generator = generators[currentIndex];
      const markResultId = generator.dataset.markResultId;
      currentIndex++;

      console.log(`开始生成第 ${currentIndex}/${this.totalValue} 个图片`);
      this.updateStatus(markResultId, "generating", "生成中...");

      try {
        await this.generateChart(generator);
        completedCount++;
        this.updateProgress(completedCount);
        this.updateStatus(markResultId, "success", "✓ 完成");
        console.log(`第 ${currentIndex} 个图片生成成功`);
      } catch (error) {
        console.error("生成失败:", error);
        completedCount++;
        this.updateProgress(completedCount);
        this.updateStatus(markResultId, "error", "✗ 失败");
      }

      setTimeout(generateNext, 500);
    };

    generateNext();
  }

  async generateChart(generator) {
    const data = generator.dataset;

    // 使用共享函数生成 canvas
    const canvas = generateChartCanvas({
      taskName: data.taskName,
      taskId: data.taskId,
      subTaskId: data.subTaskId,
      userSubTaskId: data.userSubTaskId,
      markItemId: data.markItemId,
    });

    // 转换为 Blob 并上传
    const blob = await canvasToBlob(canvas);
    await uploadChartImage(data.markResultId, blob);
  }

  updateProgress(completedCount) {
    if (this.hasProgressBarTarget && this.hasProgressTextTarget) {
      const percentage = (completedCount / this.totalValue) * 100;
      this.progressBarTarget.style.width = percentage + "%";
      this.progressTextTarget.textContent = `${completedCount} / ${this.totalValue}`;
    }
  }

  updateStatus(markResultId, status, message) {
    const statusDiv = document.querySelector(
      `#status-${markResultId} .status-indicator`,
    );
    if (!statusDiv) return;

    let badgeClass = "";
    switch (status) {
      case "generating":
        badgeClass = "bg-blue-500/20 text-blue-400 border-blue-500/50";
        break;
      case "success":
        badgeClass = "bg-green-500/20 text-green-400 border-green-500/50";
        break;
      case "error":
        badgeClass = "bg-red-500/20 text-red-400 border-red-500/50";
        break;
    }

    statusDiv.innerHTML = `<span class="px-3 py-1 text-xs rounded-full ${badgeClass} border">${message}</span>`;
  }

  getReturnUrl() {
    return this.dateValue
      ? `/mark_results?date=${this.dateValue}`
      : "/mark_results";
  }
}
